import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findAllAuth (param) {
    return axios.post(global.BASE_ACL + '/auth/findAll', param)
  }
}



// WEBPACK FOOTER //
// ./src/request/syssetting/auth.js